import * as React from 'react';
import { getHelpLogger } from '../../../../web/utils/getHelpLogger';
import { captureContentUpdate } from '../../../../web/utils/oneDsUtil';
import { AutomationIds } from '../../../models/constants/automationIds';
import { VsbUpsellAlertConstants, VsbUpsellAlertEnabledComponent } from '../../../models/constants/constants';

import { IStyledComponent } from '../styles/themesUI';
import { IVsbUpsellAlertStyles, getVsbUpsellAlertClassNames } from '../styles/vsbUpsellAlertStyles';
import UpsellAlert from './UpsellAlert';
import { getString } from '../../../../web/utils/stringLoader';

interface VsbUpsellAlertProps {
  callingComponent: VsbUpsellAlertEnabledComponent;
  shouldShowVsbUpsellAlert: boolean;
  isVsbUpsellAlertDismissed: boolean;
  isVsbUpsellAlertCTAClicked: boolean;
  compareM365PlansUrl: string;
  originalQuery: string;
  isGetHelp: boolean;
  dismissVsbUpsellAlert: (comp: VsbUpsellAlertEnabledComponent) => void;
  setCTAClickedVsbUpsellAlert: () => void;
}

type IVsbUpsellAlertProps = VsbUpsellAlertProps & IStyledComponent<IVsbUpsellAlertStyles>;

export class VsbUpsellAlert extends React.Component<IVsbUpsellAlertProps> {
  public constructor(props: IVsbUpsellAlertProps) {
    super(props);
  }

  public componentDidMount = (): void => {
    this.logTheAlert('componentDidMount');
  };

  public componentDidUpdate = (prevProps: IVsbUpsellAlertProps): void => {
    if (this.props.isVsbUpsellAlertCTAClicked !== prevProps.isVsbUpsellAlertCTAClicked ||
      this.props.isVsbUpsellAlertDismissed !== prevProps.isVsbUpsellAlertDismissed ||
      this.props.shouldShowVsbUpsellAlert !== prevProps.shouldShowVsbUpsellAlert) { // Flighting (flighting plus consumer qualification) && Query is made
      this.logTheAlert('componentDidUpdate');
    }
  };

  public render() {
    const area = VsbUpsellAlertConstants.area.selfHelpAlchemy;
    const classNames = getVsbUpsellAlertClassNames(this.props.styles, { theme: this.props.theme, isGetHelp: this.props.isGetHelp });

    // show the alert when the flag is true and the alert is not dismissed
    return (this.props.shouldShowVsbUpsellAlert && !this.props.isVsbUpsellAlertDismissed &&
      <>
        <UpsellAlert
          classNames={classNames}
          noIcon={true}
          alertDataAutomationId={AutomationIds.VSBUpsellAlert}
          buttonDataAutomationId={AutomationIds.VSBUpsellAlertCTAButton}
          iconName=''
          ariaLabel={getString('vsbUpsellAlert_alertAriaLabelText')}
          dismissButtonAriaLabel={getString('vsbUpsellAlert_dismissAlertText')}
          title={getString('vsbUpsellAlert_alertMessageTitle')}
          description={getString('vsbUpsellAlert_alertMessageDescription')}
          buttonText={getString('vsbUpsellAlert_seePlansText')}
          buttonID={VsbUpsellAlertConstants.contentIds.seePlansButton}
          area={area}
          fromnm={VsbUpsellAlertConstants.formnm}
          dismissAlert={this.dismissAlert}
          ctaClicked={this.ctaClicked}
        />
      </>
    );
  }

  private dismissAlert = () => {
    this.props.dismissVsbUpsellAlert(this.props.callingComponent);
  };

  private ctaClicked = () => {
    this.props.setCTAClickedVsbUpsellAlert();
    window.open(this.props.compareM365PlansUrl, '_blank');
  };

  // get the campaign ID from the OCID
  private getCampaignID = (url: string) => {
    const queryString = !!url ? url.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    const paramPairs = {};
    for (const [key, value] of params.entries()) {
      paramPairs[key.toLowerCase()] = value;
    }
    return paramPairs['ocid'] ?? '';
  };

  private campaignID = this.getCampaignID(this.props.compareM365PlansUrl);

  private logTheAlert(invokingMethod: string) {
    if (this.props.isVsbUpsellAlertDismissed) {
      getHelpLogger.logVSBAlertDismissed(this.campaignID);
    } else if (this.props.isVsbUpsellAlertCTAClicked) {
      getHelpLogger.logVSBAlertCTAClicked(this.props.compareM365PlansUrl, this.campaignID);
    } else if (this.props.shouldShowVsbUpsellAlert) {
      getHelpLogger.logVSBAlertLoaded(this.campaignID, invokingMethod);
    }

    const area = VsbUpsellAlertConstants.area.selfHelpAlchemy;
    const alertContent = {
      content: {
        contentId: VsbUpsellAlertConstants.contentIds.alert,
        formnm: VsbUpsellAlertConstants.formnm,
        logTrigger: invokingMethod,
        shouldShowAlert: this.props.shouldShowVsbUpsellAlert,
        isAlertDismissed: this.props.isVsbUpsellAlertDismissed,
        isCTAClicked: this.props.isVsbUpsellAlertCTAClicked,
        areaName: area,
        srchq: this.props.originalQuery,
        campaignID: this.props.isVsbUpsellAlertCTAClicked ? this.campaignID : '',
      },
      behavior: 'SHOW',
    };
    captureContentUpdate(alertContent);
  }
}
